import React from 'react';

import { AppBar, useMobileDrawer } from '@liscio/common';
import { ScreenWrapper, BodyWrapper } from '@liscio/ui';

import { Messages, Tasks, FirmSpeedDial } from './components';
import { useReloadFunction } from 'custom-hooks';
import { useProfileData } from 'fetch-utils/users/user-hooks';

export interface DashboardMobileViewProps {}

export const DashboardMobileView: React.FC<DashboardMobileViewProps> = () => {
  const { setIsDrawerOpen } = useMobileDrawer();
  const { isFirmUser } = useProfileData();

  const reloadFunction = useReloadFunction([['messages'], ['tasks']]);

  return (
    <ScreenWrapper>
      <AppBar
        onNavigationClick={() => {
          setIsDrawerOpen((currentState: boolean) => !currentState);
        }}
        title="Dashboard"
        hideSecondaryActionButton
      />
      <BodyWrapper reloadFunction={reloadFunction}>
        <Messages />
        <Tasks />
        {isFirmUser && <FirmSpeedDial />}
      </BodyWrapper>
    </ScreenWrapper>
  );
};

export default DashboardMobileView;
